/**
 * URL phiên ký.
 *
 * Partner mở `webview_url` dạng `/webview/{sessionId}`.
 * Stepper nội bộ vẫn dùng `/s/{sessionId}/{step}`.
 */
export function sessionIdFromLocation(locationLike: Pick<Location, 'pathname' | 'search'>): string | null {
  const webviewMatch = locationLike.pathname.match(/\/webview\/([^/]+)/)
  if (webviewMatch?.[1]) return decodeURIComponent(webviewMatch[1])

  const pathMatch = locationLike.pathname.match(/\/s\/([^/]+)/)
  if (pathMatch?.[1]) return decodeURIComponent(pathMatch[1])

  return new URLSearchParams(locationLike.search).get('session_id')
}

/** Token webview trên query — partner gắn khi open WebView. */
export function webviewTokenFromLocation(locationLike: Pick<Location, 'search'>): string | null {
  const params = new URLSearchParams(locationLike.search)
  return params.get('token') || params.get('webview_token') || params.get('bearer') || params.get('access_token')
}

/**
 * Bước trên path. Không dùng `pathname.includes('/ekyc')` —
 * session id `ekyc_…` trên `/webview/ekyc_…` sẽ bị nhận nhầm là bước eKYC.
 */
export function stepFromLocation(pathname: string): string | null {
  const signing = pathname.match(/^\/s\/[^/]+\/([^/]+)\/?$/)
  if (signing?.[1] && signing[1] !== 'v1') return decodeURIComponent(signing[1])

  const webview = pathname.match(/^\/webview\/[^/]+\/([^/]+)\/?$/)
  if (webview?.[1]) return decodeURIComponent(webview[1])

  return null
}

export const webviewEntryPath = (sessionId: string): string => `/webview/${encodeURIComponent(sessionId)}`
